// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = () => ({
  container: {
    width: '100%',
    margin: '20px 0',
    borderRadius: 16,
    padding: '12px',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
  },
  headerText: {
    margin: 0,
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  },
  row: {
    margin: '10px 0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  descText: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  text: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  validateText: {
    margin: '10px 0',
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_REJECT,
  }
});

export default styles;
